import {
  Select as BaseSelect,
  SelectProps,
  SelectOverrides,
} from "baseui/select";
import { Theme, useTheme } from "../ThemeProvider/ThemeProvider";

// Add widthMode prop type
interface SelectPropsWithOverride extends SelectProps {
  overrides?: SelectOverrides;
}

const Select: React.FC<SelectPropsWithOverride> = ({
  overrides = {},
  ...props
}) => {
  const { effectiveTheme } = useTheme();

  const controlContainerOverride = {
    ControlContainer: {
      style: {
        backgroundColor:
          effectiveTheme === Theme.DARK ? "rgb(11 21 35)" : "rgb(249 250 251)",
        ...(overrides?.ControlContainer?.style || {}),
      },
      ...(overrides?.ControlContainer || {}),
    },
  };

  return (
    <BaseSelect
      {...props}
      overrides={{
        ...overrides,
        ...controlContainerOverride,
      }}
    />
  );
};

export default Select;
